(function (global) {
  'use strict';

  function countUnits(rule, options) {
    if (!rule) return 0;
    if (rule.mode === 'fixed') return Number.isSafeInteger(rule.count) && rule.count > 0 ? rule.count : 0;
    if (rule.mode !== 'option') return 0;
    var option = options.find(function (entry) { return entry.name === rule.option; });
    if (!option) return 0;
    var value = String(option.value).replace(/,/g, '');
    var prefix = rule.prefix || '';
    if (!value.startsWith(prefix)) return 0;
    var numeric = value.slice(prefix.length);
    if (!/^[1-9]\d*$/.test(numeric)) return 0;
    var count = Number(numeric);
    return Number.isSafeInteger(count) ? count : 0;
  }

  function lineUnits(item, rule) {
    if (!rule) return null;
    var count = countUnits(rule, item.options_with_values || []);
    if (!count || !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
        !Number.isSafeInteger(item.quantity * count) ||
        !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) {
      throw new Error('Invalid sale-unit data for product ' + item.product_id);
    }
    return {count: count, quantity: item.quantity * count, packs: item.quantity,
      unitCents: item.final_line_price / (item.quantity * count)};
  }

  function format(template, values) {
    return template.replace(/__([A-Z]+)__/g, function (_, token) {
      var key = token.toLowerCase();
      if (!(key in values)) throw new Error('Missing unit label value: ' + key);
      return String(values[key]);
    });
  }

  var api = {countUnits: countUnits, lineUnits: lineUnits, format: format};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document || global.IlikamUnitPricing) return;
  global.IlikamUnitPricing = api;
  var configElement = document.getElementById('IlikamBulkConfig');
  if (!configElement) throw new Error('Unit-pricing configuration is missing.');
  var config = JSON.parse(configElement.textContent);
  if (!config.products) throw new Error('Catalog sale-unit registry is missing.');
  var strings = config.unitStrings;
  var currency = new Intl.NumberFormat(config.locale, {style: 'currency', currency: config.currency,
    minimumFractionDigits: 2, maximumFractionDigits: 2});
  var numbers = new Intl.NumberFormat(config.locale);
  function money(cents) { return currency.format(cents / 100); }
  function number(value) { return numbers.format(value); }
  function labels(rule) {
    var result = config.unitLabels[rule.unit];
    if (!result) throw new Error('Unknown catalog unit: ' + rule.unit);
    return result;
  }
  function quantityLabel(rule, count) {
    var label = labels(rule);
    return count === 1 ? format(strings.quantity, {unit: label.many}) :
      format(strings.packs, {quantity: number(count), unit: label.many});
  }
  api.cartPresentation = function (item) {
    var rule = config.products[String(item.product_id)];
    var units = lineUnits(item, rule);
    if (!units) return null;
    var label = labels(rule);
    return {
      unit: money(units.unitCents) + ' ' + label.per,
      summary: format(strings.cart, {quantity: number(units.quantity),
        unit: units.quantity === 1 ? label.one : label.many, packs: number(units.packs)}),
      lotsLabel: quantityLabel(rule, units.count)
    };
  };

  function initializeProduct(node) {
    if (node.dataset.initialized === 'true') return;
    var form = node.closest('form');
    var section = form && (form.closest('.quickview-description') || form.closest('.product-template__container'));
    var price = section && section.querySelector('[data-bulk-price-for="' + node.dataset.productId + '"]');
    var rule = config.products[node.dataset.productId];
    if (!form || !price || !rule) throw new Error('Missing unit-price product form or configuration.');
    var data = JSON.parse(node.textContent);
    var selectors = Array.from(form.querySelectorAll('.single-option-selector'));
    var master = form.querySelector('select[name="id"]');
    if (!master) throw new Error('Product variant selector is missing.');
    var quantity = form.querySelector('[name="quantity"]');
    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
      form.appendChild(quantity);
    }
    var label = labels(rule);
    var error = price.querySelector('[data-unit-error]');
    var buttons = Array.from(form.querySelectorAll('[name="add"]'));
    var payment = form.querySelector('.shopify-payment-button');
    var currentPrice = null;
    var gstNoteText = config.gstIncluded || '(GST included)';
    var expectedUnitText = '';
    var repairingPrice = false;
    var priceObserver = null;
    var $form = global.jQuery(form);
    var isQuick = form.classList.contains('shopify-product-quick-form');
    var url = new URL(global.location.href);

    function selectedVariant() {
      return data.variants.find(function (variant) {
        return selectors.length ? selectors.every(function (selector, index) {
          return selector.value.trim() === variant.options[index];
        }) : String(variant.id) === master.value;
      });
    }

    function repairUnitPrice() {
      price = section.querySelector('[data-bulk-price-for="' + node.dataset.productId + '"]');
      if (!price) return;
      currentPrice = price.querySelector('.product-price-current');
      if (!currentPrice || repairingPrice) return;
      repairingPrice = true;
      if (priceObserver) priceObserver.disconnect();
      var unit = currentPrice.querySelector('[data-bulk-unit-price]');
      if (!unit) {
        currentPrice.replaceChildren();
        unit = document.createElement('span');
        unit.className = 'money';
        unit.setAttribute('data-bulk-unit-price', '');
        currentPrice.appendChild(unit);
      }
      unit.textContent = expectedUnitText;
      var existingNote = currentPrice.querySelector('.unit-price-gst-note');
      if (existingNote) {
        existingNote.textContent = gstNoteText;
      } else {
        var note = document.createElement('span');
        note.className = 'unit-price-gst-note';
        note.textContent = gstNoteText;
        currentPrice.appendChild(document.createTextNode(' '));
        currentPrice.appendChild(note);
      }
      repairingPrice = false;
      if (priceObserver) {
        priceObserver.observe(currentPrice, {childList: true, subtree: true});
      }
    }

    function sync() {
      var variant = selectedVariant();
      var options = variant ? data.options.map(function (name, index) {
        return {name: name, value: variant.options[index]};
      }) : [];
      var count = countUnits(rule, options);
      var packs = Number(quantity.value);
      var valid = /^[1-9]\d*$/.test(quantity.value) && Number.isSafeInteger(packs) &&
        Number.isSafeInteger(packs * count) && Boolean(variant && Number.isSafeInteger(variant.price * packs));
      var canBuy = Boolean(variant && variant.available && count && valid);
      var message = !variant || !count ? config.strings.unavailable : (!valid ? config.strings.invalidLots : '');
      error.textContent = message;
      error.hidden = !message;
      quantity.setCustomValidity(valid ? '' : config.strings.invalidLots);
      buttons.forEach(function (button) { button.disabled = !canBuy; });
      if (payment) payment.style.display = canBuy ? '' : 'none';
      if (!variant || !count) {
        price.querySelector('[data-bulk-unit-price]').textContent = config.strings.unavailable;
        price.querySelector('[data-bulk-order-total]').textContent = '';
        price.querySelector('[data-bulk-compare-price]').classList.add('hide');
        return;
      }
      master.value = String(variant.id);
      if (isQuick) {
        form.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = variant.id; });
        $form.find('[data-product-varient-id]').attr('data-product-varient-id', variant.id)
          .data('product-varient-id', variant.id);
      }
      expectedUnitText = money(variant.price / count);
      repairUnitPrice();
      var comparison = price.querySelector('[data-bulk-compare-price]');
      comparison.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price / count) : '';
      comparison.classList.toggle('hide', !(variant.compare_at_price > variant.price));
      price.querySelector('[data-bulk-order-total]').textContent = valid ? format(strings.order, {
        price: money(variant.price * packs), quantity: number(count * packs),
        unit: count * packs === 1 ? label.one : label.many
      }) : '';
      var quantityBlock = quantity.closest('.dt-sc-qty');
      var caption = quantityBlock && quantityBlock.querySelector('.product-label');
      var captionText = quantityLabel(rule, count);
      if (caption) caption.textContent = captionText;
      quantity.setAttribute('aria-label', captionText);
      if (!isQuick && section.classList.contains('template-product')) {
        url.searchParams.set('variant', String(variant.id));
        global.history.replaceState(global.history.state, '', url);
      }
    }

    function select(id) {
      var variant = data.variants.find(function (entry) { return String(entry.id) === String(id); });
      if (!variant) { sync(); return; }
      master.value = String(variant.id);
      selectors.forEach(function (selector, index) { selector.value = variant.options[index]; });
      if (selectors.length) global.jQuery(selectors[0]).trigger('change');
      sync();
    }

    $form.on('change.catalogUnits', '.single-option-selector', sync);
    $form.on('input.catalogUnits change.catalogUnits', '[name="quantity"]', sync);
    $form.on('click.catalogUnits', '.btn-number', function () { global.setTimeout(sync, 0); });
    form.addEventListener('submit', function (event) {
      sync();
      if (!selectedVariant() || buttons.some(function (button) { return button.disabled; }) || !quantity.checkValidity()) {
        event.preventDefault(); event.stopImmediatePropagation();
        error.hidden = false; error.textContent = config.strings.unavailable;
      }
    }, true);
    if (!isQuick) global.addEventListener('popstate', function () {
      if (!node.isConnected) return;
      url = new URL(global.location.href);
      select(url.searchParams.get('variant') || node.dataset.selectedVariant);
    });
    node.dataset.initialized = 'true';
    if (price) {
      priceObserver = new MutationObserver(repairUnitPrice);
      priceObserver.observe(section, {childList: true, subtree: true});
    }
    select(node.dataset.selectedVariant);
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-unit-product]')) initializeProduct(scope);
    scope.querySelectorAll('[data-unit-product]').forEach(initializeProduct);
    scope.querySelectorAll('[data-bulk-cart-pricing]').forEach(function (node) {
      var row = node.closest('.cart__row');
      var input = row && row.querySelector('[name="updates[]"]');
      if (input) input.setAttribute('aria-label', quantityLabel({unit: node.dataset.unitKind}, Number(node.dataset.piecesPerLot)));
    });
  }
  global.jQuery(function () {
    initializeAll(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) initializeAll(node);
        });
      });
    }).observe(document.body, {childList: true, subtree: true});
  });
}(typeof window === 'undefined' ? globalThis : window));
